export default __webpack_public_path__ + "static/media/trr-drink-specialty-immunity.b20cb87c.png";